import { Highlight } from "@tiptap/extension-highlight";

/**
 * Theme-aware Highlight extension.
 *
 * This extends TipTap's Highlight extension to support theme-aware colors.
 *
 * - Stores the light-mode color in both `data-color` attribute AND inline style
 * - The `data-color` attribute is used by CSS to override colors in dark mode
 * - Inline style ensures the highlight is visible in light mode
 * - CSS uses `!important` to override inline styles in dark mode
 */
export const ThemeAwareHighlight = Highlight.extend({
  addAttributes() {
    if (!this.options.multicolor) {
      return {};
    }

    return {
      color: {
        default: null,
        parseHTML: (element) =>
          element.getAttribute("data-color") ||
          element.style.backgroundColor ||
          null,
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {};
          }

          // Set BOTH data-color (for CSS dark mode override) AND inline style (for light mode).
          // Do not use !important on background-color — it blocks index.css dark-theme overrides.
          return {
            "data-color": attributes.color,
            style: `background-color: ${attributes.color}; color: inherit`,
          };
        },
      },
    };
  },
});

export default ThemeAwareHighlight;
